import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme: any) => ({
    root: {
        fontSize: '26px',
        color: theme.palette.black,
        fontWeight: 'bold',
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        minHeight: 0,
    },
    title: {
        fontSize: '24px',
        color: theme.palette.black,
        fontWeight: 'bold',
    },
    pagination: {
        display: 'flex',
        flex: 1,
        justifyContent: 'flex-end',
        padding: '20px',
        alignItems: 'center',
        flexWrap: 'wrap',
    },
    clearFilterButton: { textTransform: 'capitalize', fontSize: '12px', marginTop: '10px' },
    filterContainer: {
        display: 'flex',
        flexDirection: 'row',
        flex: 1,
        gap: '5px',
        justifyContent: 'center',
    },
}));
